export class PrivacyNoticeDto {
  constructor(
    public version: number | null,
    public name: string | null,
    public bodyMultiline: string | null,
    public acknowledged: boolean
  ) {}

  public static from(obj: PrivacyNoticeDto) {
    return new PrivacyNoticeDto(
      obj.version,
      obj.name,
      obj.bodyMultiline,
      obj.acknowledged
    );
  }
}
